<template>
    <div class="appVersion">
        <div>
            <form :form="form" @submit.prevent="query">
                <div style="display: flex;justify-content: space-between;align-items: center;">
                    <div class="logQuery">
                        <InputField style="margin: 0.1rem 0.1rem 0.1rem 0;width:20%" labelWidth="0" type="text" id="inventoryOrder"
                                    v-model="form.inventoryOrder" placeholder="盘点单号"
                                    @update:modelValue="(value) => handleModelValueUpdate('inventoryOrder', value)"
                        />
                        <SelectField labelWidth="0" style="margin: 0.1rem 0.1rem 0.1rem 0.7rem;padding:0 0.2rem;width:20%;" :options="statusList"
                                     v-model="form.status" id="status" placeholder="盘点状态"
                                     @update:modelValue="(value) => handleModelValueUpdate('status', value)"
                        />
                        <RangePickerField label-width="0" v-model="form.time" style="width: 40%;"
                                :placeholder="['开始盘点时间', '结束盘点时间']" :disabled="false"
                                @update:modelValue="(value) => handleModelValueUpdate('time', value)"
                        />
                        <a-space style="margin: 0 0 0 0.5rem;width:25%">
                            <ButtonField text="查询" @click="query" secondary />
                            <ButtonField text="重置" primary @click="reset"/>
                        </a-space>
                    </div>
                    <div class="right">
                        <ButtonField text="创建盘点单" @click="$emit('show-check-add')" secondary />
                    </div>
                </div>
            </form>
        </div>
        <Tablelist
                style="margin-top: 1rem"
                :showCheckbox="false"
                :list="list"
                :columns="tableColumns"
        >
            <template #template-status="{ item }">
                <DataDictFinder dictType="AssetInventoryStatus" :dictValue="item.status" iconType="text"/>
            </template>
            <template v-slot:actions="{ item }">
                <a-space>
                    <a @click="$emit('show-check-detail',item.id)">
                        <span v-if="item.status === 'FINISHED'">详情</span>
                        <span v-else>盘点</span>
                    </a>
                    <a v-if="item.progress !== 100" @click="$emit('show-check-edit',item.id)"
                    >编辑</a>
                    <a class="danger" v-if="item.status !== 'DELETED'" @click.prevent="deleteText(item)"
                    >删除</a>
                </a-space>
            </template>
        </Tablelist>
    </div>
</template>
<script>
import { fetchList, cancel, remove } from "../api/check";
import { mapGetters } from "vuex";
export default {
  data() {
    return {
      form: {},
      list: [],
      loading: false,
      total: 0,
      current: 1,
      pageSize: 10,
      tableColumns: [
          {
              key: 'inventoryOrder',
              title: '盘点单号',
              field: 'inventoryOrder',
              infotype: 'text'
          },
          {
              key: 'inventoryTime',
              title: '盘点开始时间',
              field: 'inventoryTime',
              infotype: 'text',
          },
          {
              key: 'applicant',
              title: '盘点负责人',
              field: 'applicant',
              infotype: 'text',
          },
          {
              key: 'status',
              title: '盘点状态',
              field: 'status',
              infotype: 'template',
          },
          {
              key: 'allMaterialSize',
              title: '盘点资产数量',
              field: 'allMaterialSize',
              infotype: 'text',
          },
          {
              key: 'checkProgress',
              title: '盘点进度',
              field: 'checkProgress',
              infotype: 'text',
          },
          {
              key: 'actions',
              title: '操作',
              infotype: 'template',
          }
      ],
    };
  },
  mounted() {
    this.getList();
  },
  computed: {
    ...mapGetters("setting", ["findDataDict"]),
    statusList() {
      return this.findDataDict("AssetInventoryStatus");
    },
  },
  methods: {
    handleModelValueUpdate(fieldName, value) {
      this.form[fieldName] = value;
    },
    getList() {
      this.loading = true;
      let { current, pageSize, form } = this;

      let inventoryTimeStart, inventoryTimeEnd;
      if (Array.isArray(form.time) && form.time.length === 2) {
        inventoryTimeStart = form.time[0].format("YYYY-MM-DD");
        inventoryTimeEnd = form.time[1].format("YYYY-MM-DD");
      }
      fetchList({
        pageNum: current,
        pageSize,
        ...form,
        time: undefined,
        inventoryTimeStart,
        inventoryTimeEnd,
      })
        .then((res) => {
          this.loading = false;
          if (Array.isArray(res.list)) {
            this.list = res.list;
            this.total = res.totalSize;
          }
        })
        .catch(() => {
          this.loading = false;
        });
    },
    onChange(pagination) {
      this.current = pagination.current;
      this.pageSize = pagination.pageSize;
      this.getList();
    },
    reset() {
      this.form = {};
      this.current = 1;
      this.getList();
    },
    query() {
      this.current = 1;
      this.getList();
    },

    cancelText(text) {
      const that = this;
      this.$confirm({
        title: "确认要取消吗？",
        onOk() {
          cancel({
            id: text.id,
          }).then(() => {
            that.getList();
          });
        },
      });
    },
    deleteText(text) {
      const that = this;
      this.$confirm({
        title: "确认要删除吗？",
        onOk() {
          remove({
            id: text.id,
          }).then(() => {
            that.getList();
          });
        },
      });
    },
  },
};
</script>
<style lang="less" scoped>
.logQuery{
  display: flex;
  justify-content: start;
  //width: 80%;
}
.right ::v-deep Button{
  margin: 0 0.2rem;
}
</style>